import {useMemo} from 'react';
import {HtmlContent} from '@client/utils/html_content';
import {stripHtml} from '@client/utils/stripHtml';

/**
 * EPI general comments (product + treatment sheets): one grey box, green title
 * inside, comments sorted alphabetically (plain text, fr) and stacked.
 * `comments`: [{id, comment}] as serialized in `epi_general_comment`.
 * `text`: when given, rendered as the single content instead of `comments`.
 */
const EpiGeneralComment = ({title, comments, text}) => {
    const sorted = useMemo(
        () => (comments || [])
            .map((item) => ({...item, text: stripHtml(item?.comment || '').trim()}))
            .filter((item) => item.text)
            .sort((a, b) => a.text.localeCompare(b.text, 'fr', {numeric: true, sensitivity: 'base'})),
        [comments]
    );

    if (!text && sorted.length === 0) return null;

    return (
        <div className="bg-[#F5F5F5] rounded-[16px] px-6 py-4 flex flex-col gap-4">
            <h3 className="text-[16px] font-bold text-[#3F6600] normal-case m-0">{title}</h3>
            {text
                ? <HtmlContent html={text} as="div"/>
                : sorted.map((item, index) => (
                    <HtmlContent key={item.id || index} html={item.comment} as="div"/>
                ))}
        </div>
    );
};

export default EpiGeneralComment;
